import { isAxiosError } from "axios";

/**
 * Returns the error message from an error object, with details that can be useful for developers.
 * To be used internally only.
 *
 * @param error - The error to get the message from
 * @returns The error message
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getErrorMessageInternal(error: any): { message: string; numberOfErrors?: number } {
  let errorMessage =
    error instanceof Error || (typeof error === "object" && "message" in error)
      ? error.message
      : String(error);
  if (isAxiosError(error)) {
    const additionalInfo = error.response?.data.additionalInfo;
    if (additionalInfo && additionalInfo?.allErrorMessages && additionalInfo?.numberOfErrors) {
      return extractValidationErrors(
        additionalInfo.allErrorMessages,
        additionalInfo.numberOfErrors
      );
    }
    const message = error.response?.data.detail;
    if (typeof message === "string") errorMessage = message;
  }
  return { message: errorMessage };
}

export function extractValidationErrors(
  allErrorMessages: string,
  numberOfErrors: number
): { message: string; numberOfErrors: number } {
  const cleaned = allErrorMessages
    .split(/;\n?/)
    .map((msg: string) => msg.replace(/^Error:\s*/, "").trim())
    .filter(Boolean);

  const message = `Feature flag validation returned ${numberOfErrors} error${
    numberOfErrors === 1 ? "" : "s"
  }\n${cleaned.join("\n")}`;
  return { message, numberOfErrors };
}
